<template>
  <div class="HmoreBtn">
    <div
      class="eareItemImg"
      @mouseover="handleMoreOperation(itemRow)"
      @mouseleave="handleMoreLeave(itemRow)"
    >
      <div class="xsd">相似度{{ itemRow.similarity }}</div>
      <el-image :src="itemRow.imagePartUrl" :initial-index="4" fit="cover">
      </el-image>

      <div class="moreBtn" @click="moreClick">
        <!-- 更多操作 -->
        <i :class="['iconfont', 'icon-zhuangbei']" v-show="moreOperation"></i>
        <div class="moreSelect" v-show="moreFalse">
          <div
            class="moreList"
            v-for="(it, ind) in moreSelectList"
            :key="ind"
            @click.stop="moreClickList(it)"
          >
            <i :class="['iconfont', it.icon]"></i>
            {{ it.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <h-big-picture
    :pictureUrl="itemRow.imageUrl"
    v-model:visible="ckdtShow"
    v-if="ckdtShow"
  ></h-big-picture>
  <!-- <el-dialog v-model="ckdtShow" title="查看大图" width="50%">
    <img class="imgDetialStyle" :src="itemRow.imageUrl" />
  </el-dialog> -->
  <el-dialog title="详情" v-model="ryxqShow" width="1200px">
    <h-name-detail
      v-if="ryxqShow"
      :itemRowIndex="itemRowIndex"
      :itemRow="itemRow"
    ></h-name-detail>
  </el-dialog>
  <el-dialog title="名单库" v-model="mdkShow" width="1200px">
    <h-table
      ref="tableRef"
      v-model:data="tableData"
      v-model:columns="columns"
      :method="repositorylist"
      :params="tableParams"
      @select="hzTableSelect"
      style="height: 500px"
    >
    </h-table>
  </el-dialog>
</template>
<script>
import { defineComponent, watchEffect, reactive, toRefs } from "vue";
import { useRouter } from "vue-router";
import util from "@util/js";
import {
  repositorylist,
  urlToBase,
  urlToBlob,
  url2ToBase,
} from "@/api/smartApplication/personSearchApi.js";
export default defineComponent({
  name: "HMoreBtn",
  props: {
    itemRow: {
      type: Object,
      default: () => {},
    },
    itemRowIndex: {
      type: Number,
      default: 0,
    },
    moreSelect: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["imageListUrl"],
  setup(props, context) {
    const router = useRouter();
    const data = reactive({
      ckdtShow: false,
      ryxqShow: false,
      defaultOpen: true,
      mdkShow: false,
      moreOperation: false, // 展示更多操作
      moreFalse: false,
      moreSelectList: [
        { name: "查看大图", icon: "icon-fangda", path: "dt" },
        { name: "下载", value: "icon-shexiangtou1", path: "xz" },
        // { name: "身份稽查", value: "icon-shenfenzheng", path: "", }
      ],
      tableData: [],
      tableParams: {},
      columns: [
        { type: "selection", value: 1 },
        { type: "index" },
        {
          label: "名单库名称",
          prop: "name",
        },
        {
          label: "类型",
          prop: "type",
        },
        {
          label: "是否下发名单库",
          prop: "cardNumber",
        },
      ],
    });
    watchEffect(() => {
      data.moreSelectList = data.moreSelectList.concat(props.moreSelect);
    });
    const handleMoreOperation = (item) => {
      data.moreOperation = true;
      data.showEareItem = item.value;
    };
    const handleMoreLeave = () => {
      data.moreOperation = false;
      data.moreFalse = false;
    };
    const moreClick = () => {
      data.moreFalse = true;
    };
    const moreClickList = async (item) => {
      // if (item.router) {
      //   window.open(window.openURL + item.router, "_blank");
      // }
      if (item.path === "xz") {
        const url = "/imgApi/?" + props.itemRow.imageUrl.split("/?")[1];
        util.downImgFile(url);
      } else if (item.path === "dt") {
        data.ckdtShow = true;
      } else if (item.path === "ss") {
        const path = {
          paths: [props.itemRow.imagePartUrl],
        };
        const res = await url2ToBase(path);
        context.emit("imageListUrl", res.data[0]);
      } else if (item.path === "ryxq") {
        data.ryxqShow = true;
      } else if (item.path === "mdk") {
        data.mdkShow = true;
      } else if (item.path === "sfjc") {
        router.push({
          path: "identityCheck",
          query: { img: props.itemRow.imagePartUrl },
        });
      }
      data.moreFalse = false;
    };

    return {
      ...toRefs(data),
      moreClickList,
      moreClick,
      handleMoreOperation,
      handleMoreLeave,
      repositorylist,
    };
  },
});
</script>
<style lang="scss" scoped>
.HmoreBtn {
  height: 80%;
  .eareItemImg {
    position: relative;

    height: 100%;
    .xsd {
      position: absolute;
      z-index: 1;
      width: 100%;
      font-size: 12 px;
      min-height: 24px;
      color: #fff;
      line-height: 28px;
      text-align: center;
      background-color: rgba(26, 44, 101, 0.6);
    }
    .el-image {
      height: 100%;
      width: 100%;
    }
    .downBtn {
      padding: 3px 5px;
      background: rgba(0, 0, 0, 0.5);
      // border-radius: 5px;
      position: absolute;
      width: 100%;
      top: 0;
      text-align: center;
      cursor: pointer;
    }
    .moreBtn {
      position: absolute;
      width: 100%;
      z-index: 2;
      text-align: center;
      color: #fff;
      background: rgba(0, 0, 0, 0.5);
      bottom: 0px;
      cursor: pointer;
    }
  }

  .topTooltip {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 30px;
    line-height: 30px;
    color: #333;
    font-size: 14px;
  }

  .moreSelect {
    position: absolute;
    font-size: 14px;
    bottom: 21px;
    background: rgba(0, 0, 0, 1);
    width: 100%;
    max-height: 150px;
    overflow: auto;
    // border-radius: 4px;
    line-height: 28px;
    cursor: pointer;
  }
}
.imgDetialStyle {
  width: 100%;
}
</style>
